import { userDtos } from '@vectronic/openApi-customer';

export const COLLAR_GROUPS: userDtos.Group[] = [
  {
    id: 1111,
    name: 'Group_1',
    label: 'label',
    membersIds: [1, 2, 4, 5],
    description: 'Description_Group_1',
    role: 'OWNER',
  },
  {
    id: 1112,
    name: 'Group_2',
    label: 'label',
    membersIds: [3, 4, 5],
    description: 'Description_Group_2',
    role: 'OWNER',
  },
  {
    id: 1113,
    name: 'Group_3',
    label: 'label',
    membersIds: [7, 11, 12],
    description: 'Description_Group_3',
    role: 'OWNER',
  },
  {
    id: 96,
    name: 'efefef',
    label: 'label',
    membersIds: [2, 7, 11, 42, 72, 87, 89, 45, 79, 37, 84, 62, 1303, 247, 248, 33],
    description: 'vvvvvvvvvvv',
    role: 'OWNER',
  },
  {
    id: 816,
    name: 'Group_5',
    label: 'label',
    membersIds: [4, 5, 6],
    description: '',
    role: 'OWNER',
  },
];
